import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPageData, UIError } from 'common/interfaces';
import {
  DayReportEntryType,
  IDayReport,
  IDayReportLoadingType,
  IDayReportState,
  IDayReportUpdateType,
} from 'common/interfaces/iDayReports';
import { merge } from 'lodash';

const initialState: IDayReportState = {
  loading: false,
  loadingStatus: undefined,
  error: undefined,
  draftReports: undefined,
  reports: undefined,
  updated: undefined,
  ongoingDayReport: undefined,
};

const reducers = {
  setLoading: (state: IDayReportState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setDataLoading: (state: IDayReportState, action: PayloadAction<{ type: DayReportEntryType; isLoading: boolean }>) => {
    if (!state.loadingStatus) {
      state.loadingStatus = {} as IDayReportLoadingType;
    }
    state.loadingStatus[action.payload.type] = action.payload.isLoading;
  },
  setError: (state: IDayReportState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IDayReportState) => {
    console.log('Resetting report context');
    merge(state, initialState);
  },

  setDataUpdated: (state: IDayReportState, action: PayloadAction<{ type: DayReportEntryType; isUpdated: boolean }>) => {
    if (!state.updated) {
      state.updated = {} as IDayReportUpdateType;
    }
    state.updated[action.payload.type] = action.payload.isUpdated;
  },

  resetDataUpdated: (state: IDayReportState) => {
    state.updated = {} as IDayReportUpdateType;
    state.error = undefined;
  },
  setReports: (
    state: IDayReportState,
    action: PayloadAction<{
      data: IPageData<IDayReport> | undefined;
      append: boolean;
    }>,
  ) => {
    if (!action.payload.append) {
      state.reports = action.payload.data;
    } else if (action.payload.data) {
      const stReports = state.reports?.items || [];
      const playloadItems = action.payload.data?.items || [];
      state.reports = {
        ...action.payload.data,
        items: [...stReports, ...playloadItems],
      };
    }
  },
  setDraftReport: (state: IDayReportState, action: PayloadAction<IPageData<IDayReport> | undefined>) => {
    state.draftReports = action.payload;
  },
  setOngoingReport: (state: IDayReportState, action: PayloadAction<IDayReport | undefined>) => {
    state.ongoingDayReport = action.payload;
  },
};

const dayReportSlice = createSlice({
  name: 'IDayReportState',
  initialState: initialState,
  reducers: reducers,
});

export default dayReportSlice.reducer;
export const DayReportActions = dayReportSlice.actions;
